/**
 * Horizontal gap between the floating dismiss control and its adjacent input.
 * Matches Tailwind `gap-1` / the `px-1` edge inset on the default AboveKeyboard wrapper.
 */
export const ABOVE_KEYBOARD_EDGE_GAP_PX = 4;

/**
 * Vertical padding between AboveKeyboard content (and the floating search bubble) and the
 * keyboard top.
 */
export const ABOVE_KEYBOARD_BOTTOM_GAP_PX = 9;
